<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <rest-record-item
    :key="[type, pageType].join('')"
    :type="type"
    :pageType="pageType"
    :restData="restData"
    @tab="onTab"
    @pageTypeChange="onPageTypeChange"
  ></rest-record-item>
</template>

<script>
/** 余额记录 */
import apis from '@/utils/apis';
import restRecordItem from './children/rest_record_item.vue';

export default {
  name: 'restRecord',
  mixins: [],
  components: {
    restRecordItem
  },
  props: {
  },
  data() {
    return {
      // 1 - 账户余额  2 - 使用历史
      type: 1,
      // 1 - 支出  2 - 收入
      pageType: 1,
      restData: {
        // 账户余额
        balanceAmount: 0,
        // 可用余额
        canUseAmount: 0,
        // 不可用金额
        lockAmount: 0,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onTab(value) {
      this.type = value;
    },
    onPageTypeChange(value) {
      this.pageType = value;
    },
    // 获取租赁余额
    getRestCount() {
      return this.$getJSON(apis.portalTotalTermBalance).then((res) => {
        this.restData = res.data;
      });
    },
  },
  created() {
  },
  mounted() {
    this.getRestCount();
  },
};
</script>

<style>
</style>
